// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"dbc856bd","596":"e972bbdd"}[chunkId] + ".chunk.css";
};